import { render, staticRenderFns } from "./PdfLayout.vue?vue&type=template&id=2c0ae80d&scoped=true"
import script from "./PdfLayout.vue?vue&type=script&lang=js"
export * from "./PdfLayout.vue?vue&type=script&lang=js"
import style0 from "./PdfLayout.vue?vue&type=style&index=0&id=2c0ae80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ae80d",
  null
  
)

export default component.exports